import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .no-record-label {
    font-weight: 700;
    font-size: 1.25rem;
    margin: 0.75rem 0;
    color: var(--cdv-font);
  }

  .no-record-sub-label {
    color: var(--cdv-font);
    opacity: 0.8;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .button-wrapper {
    margin: 1.5rem 0;
  }

  .explore-more-rates {
    width: 11.375rem;
    height: 2.625rem;
    font-weight: 600;
    font-size: 1rem;
    background: var(--cdv-btn-bg) !important;
    color: var(--cdv-btn-text) !important;
    opacity: 1 !important;
  }
  .explore-top-cd-rates {
    height: 2.625rem;
    background: #12A5BC !important;
    font-weight: 600;
    font-size: 1rem;
    color: var(--White);
    opacity: 1 !important;
    border:none !important
  }
`;
